<template>
  <div>
    <el-row>
      <el-col :span="20">
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="送货日期：">
            <el-date-picker size="medium" v-model="searchForm.date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
              :clearable="false" style="width: 200px;"></el-date-picker>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select size="medium" filterable v-model="searchForm.STATUS">
              <el-option v-for="item in statusList" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目点分组名称：">
            <el-select size="medium" clearable v-model="searchForm.GROUP_ID">
              <el-option v-for="item in clientList" :key="item.GROUP_ID" :value="item.GROUP_ID"
                :label="item.PROJECT_GROUP"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="queryTable" style="float:right">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4">
        <el-button size="medium" type="primary" plain @click="exportExcel">导出</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-tabs type="border-card" @tab-click="handleTabClick">
          <el-tab-pane label="团餐客户">
            <el-table stripe border :data="tableData" style="margin-top:20px">
              <el-table-column label="序号" type="index" width="50"></el-table-column>
              <el-table-column label="分类名称" prop="CATALOG_NAME"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button @click="openTotal(scope.row)" type="text">查看汇总</el-button>
                  <el-button @click="openDetail(scope.row)" type="text">查看明细</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="供应商客户">
            <el-table stripe border :data="tableData" style="margin-top:20px">
              <el-table-column label="序号" type="index" width="50"></el-table-column>
              <el-table-column label="分类名称" prop="CATALOG_NAME"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button @click="openTotal(scope.row)" type="text">查看汇总</el-button>
                  <el-button @click="openDetail(scope.row)" type="text">查看明细</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { exportPurchase } from 'api/purchaseOrder';
import { getClientGroupFun } from 'api/systemSetting';
import date from '@/assets/common/date';
import http from '@/assets/common/http';
import { getFormatDay } from '@/assets/common/common';

export default {
  data() {
    return {
      searchForm: {
        date: getFormatDay(1, '-'),
        STATUS: '0',
        GROUP_ID: '',
      },
      clientList: [],
      tableData: [],
      name: '',
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      statusList: [
        {
          ID: '0',
          NAME: '未处理',
        },
        {
          ID: '1',
          NAME: '已处理',
        },
      ],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    if (JSON.stringify(this.PURCHASE_SEARCH) !== '{}') {
      this.searchForm = this.PURCHASE_SEARCH;
      this.queryTable();
    } else {
      this.searchForm.date = getFormatDay(1, '-');
      this.queryTable();
    }
    this.queryClientGroup();
  },
  computed: {
    PURCHASE_SEARCH() {
      return this.$store.state.PURCHASE_SEARCH;
    },
  },
  methods: {
    // ----------------------------拉取数据
    queryTable() {
      const params = {
        SERVICE_ID: '10049',
        OTYPE: 6,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        SEND_DAY: this.searchForm.date,
      };
      if (this.searchForm.date == null) {
        this.$message.show({ text: '请选择送货日期', type: 'warning' });
        return false;
      }
      if (this.currentOrderFlag == 1) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      if (this.searchForm.STATUS) {
        params.PROCESSED_FLAG = this.searchForm.STATUS;
      }
      if (this.searchForm.GROUP_ID) {
        params.GROUP_ID = this.searchForm.GROUP_ID;
      }
      this.loading = true;
      http.post(params).then((result) => {
        this.tableData = result;
        this.loading = false;
        this.$store.dispatch('SET_PURCHASE_SEARCH', this.searchForm);
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 获取用户分组
    queryClientGroup() {
      getClientGroupFun().then((result) => {
        this.clientList = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ----------------------------导出
    exportExcel() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SEND_DAY: date(this.searchForm.date, '%F'),
          };
          if (this.currentOrderFlag == 1) {
            params.IS_SUPPLIER_CLIENT = 1;
          }
          if (this.searchForm.GROUP_ID) {
            params.GROUP_ID = this.searchForm.GROUP_ID;
          }
          exportPurchase(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    openTotal(row) {
      this.$router.push({ name: 'totalPurchase' });
      sessionStorage.setItem('kindId', row.CATALOG_ID);
      sessionStorage.setItem('sendDay', this.searchForm.date);
      sessionStorage.setItem('currentOrderFlag', this.currentOrderFlag);
      sessionStorage.setItem('GROUP_ID', this.searchForm.GROUP_ID);
    },
    openDetail(row) {
      this.$router.push({ name: 'detailPurchase' });
      sessionStorage.setItem('kindId', row.CATALOG_ID);
      sessionStorage.setItem('sendDay', this.searchForm.date);
      sessionStorage.setItem('currentOrderFlag', this.currentOrderFlag);
      sessionStorage.setItem('GROUP_ID', this.searchForm.GROUP_ID);
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
    handleTabClick(tab, event) {
      this.currentOrderFlag = Number(tab.index);
      this.queryTable();
    },
    // 导出汇总
    exportTotal(row) {
      const params = {
        SERVICE_ID: '10022',
        OTYPE: 2,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SEND_DAY: date(this.searchForm.date, '%F'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        CATALOG_ID: row.CATALOG_ID,
      };
      http.post(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 导出明细
    exportDetail(row) {
      const params = {
        SERVICE_ID: '10022',
        OTYPE: 4,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SEND_DAY: date(this.searchForm.date, '%F'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        CATALOG_ID: row.CATALOG_ID,
      };
      http.post(params)
        .then((result) => {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
  },
};
</script>
<style scoped>
.product {
  color: #606266;
  padding-left: 5px;
  height: 40px;
}

.table-title {
  height: 50px;
  line-height: 50px;
  border: 1px solid #ebeef5;
  color: #909399;
  font-weight: bold;
  border-bottom: 0;
}

.table-line {
  float: left;
  width: 50%;
}

.sending,
.sending tr th,
.sending tr td {
  border: 1px solid #ebeef5;
}

.product-title {
  border-top: 0 !important;
  border-bottom: 0 !important;
  color: #606266;
  padding-left: 5px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/sendDocument/purchaseOrder.vue